import React from "react";
import { useNavigate } from "react-router-dom";

const ArtistList = (props) => {
  const navigate = useNavigate();
  const { allArtists, loading } = props;

  return (
    <div className="row author_list mt-2">
      {loading ? (
        <h5>Please wait! Loading artists...</h5>
      ) : allArtists?.length > 0 ? (
        allArtists?.map((artist, i) => {
          return (
            <div
              className="col-md-4 col-sm-12 mb-5"
              style={{ display: "flex", alignItems: "center" }}
              key={i}
            >
              <div className="author_list_pp" style={{ position: "initial" }}>
                <span onClick={() => navigate(`/artists/${artist.id}`)}>
                  {artist?.profileImage ? (
                    <img
                      className="lazy"
                      src={artist.profileImage}
                      alt=""
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "/img/author/dummy_author.png";
                      }}
                      style={{ position: "initial" }}
                    />
                  ) : (
                    <div className="no-img">
                      {artist.firstName.charAt(0).toUpperCase()}
                    </div>
                  )}
                </span>
              </div>
              <div className="author_list_info">
                <span
                  id="limit-content-length"
                  onClick={() => navigate(`/artists/${artist.id}`)}
                  style={{ width: "200px" }}
                >
                  {artist.firstName.concat(" ", artist.lastName)}
                </span>
                {/* {location.pathname !== "/" && (
                  <span
                    id="limit-content-length"
                    className="bot"
                    style={{ width: "200px" }}
                    onClick={() => navigate(`/artist/${artist.artistId}`)}
                  >
                    {artist.description}
                  </span>
                )} */}
              </div>
            </div>
          );
        })
      ) : (
        <div className="d-flex justify-content-center">
          <p style={{ fontSize: "18px" }}>No artists available.</p>
        </div>
      )}
    </div>
  );
};

export default ArtistList;
